import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import IconLibrary from "./icon-library.js";

const Wrapper = styled.div`
  font-family: var(--font-paragraphs);
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: var(--box-shadow);
  border-bottom: 1px solid var(--color-grey);
  border-left: none;
  border-right: none;
  &:first-of-type {
    border-top: 1px solid var(--color-grey);
  }
  &:last-of-type {
    margin-bottom: 1rem;
  }
`;
const Question = styled.div`
  cursor: pointer;
  align-items: center;
`;
const Text = styled.div`
  padding: 1.5rem 1.5rem 1.5rem 1.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || `var(--color-white)`};
  color: ${({ $textColor }) => $textColor};
  border-radius: ${({ $isOpen }) =>
    $isOpen
      ? `var(--border-radius) var(--border-radius) 0 0`
      : `var(--border-radius);`};
`;
const CloseIcon = styled(FontAwesomeIcon)`
  color: ${({ $textColor }) => $textColor};
  margin-right: 1rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-right: 0;
  }
`;
const Answer = styled.div`
  display: flex;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || `var(--color-white)`};
  color: ${({ $textColor }) => $textColor};
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  visibility: hidden;
  transition: all 0.2s ease-in;
  border-radius: 0 0 var(--border-radius) var(--border-radius);

  &.visible {
    opacity: 1;
    max-height: 100%;
    visibility: visible;
  }
  span {
    padding: 1.2rem;
  }
`;

export default function Accordion({
  question,
  answer,
  backgroundColor,
  textColor,
}) {
  const [isOpen, setOpen] = React.useState(false);

  const toggleAnswer = () => {
    setOpen(!isOpen);
  };

  return (
    <Wrapper $isOpen={isOpen}>
      <IconLibrary />
      <Question
        itemScope
        itemProp="mainEntity"
        itemType="https://schema.org/Question"
        onClick={toggleAnswer}
      >
        <Text
          $backgroundColor={backgroundColor}
          $textColor={textColor}
          $isOpen={isOpen}
        >
          <span
            itemProp="name"
            dangerouslySetInnerHTML={{ __html: question }}
          />
          <CloseIcon
            icon={isOpen ? faAngleUp : faAngleDown}
            size="1x"
            $textColor={textColor}
          />
        </Text>
        <Answer
          itemScope
          itemProp="acceptedAnswer"
          itemType="https://schema.org/Answer"
          className={isOpen ? "visible" : ""}
          $backgroundColor={backgroundColor}
          $textColor={textColor}
        >
          <span itemProp="text" dangerouslySetInnerHTML={{ __html: answer }} />
        </Answer>
      </Question>
    </Wrapper>
  );
}

Accordion.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
};

Accordion.defaultProps = {
  question: undefined,
  answer: undefined,
};
